import React from 'react';
import i18n from 'i18next';
import Folder from '@mui/icons-material/Folder';

import { Typo } from 'uikit/content';

import styles from '../styles/topicChips.module.scss';

const TopicChips = ({ topics }) => (
  <ul className={styles.element}>
    {!topics.length ? (
      <li>
        <Typo className={styles.empty} variant="b01">
          {i18n.t('topic-selection-empty')}
        </Typo>
      </li>
    ) : (
      topics.map(({ id, name }) => (
        <li className={styles.topic} key={id}>
          <Folder className={styles.icon} sx={{ height: 16, width: 16 }} />
          <Typo className={styles.text} element="span" variant="b01">{name}</Typo>
        </li>
      ))
    )}
  </ul>
);

export default React.memo(TopicChips);
